const oidc = {
    logout_success: 'Başarıyla çıkış yaptınız.',
};
export default oidc;
